import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const loginUserSlice = createSlice({
  name: 'loginUser',
  initialState: {
    step: 'guest',
    checkbox: false,
    loading: false,
    showPassword: false,
    tempCookie: {},
    loginFeedback:'',
    username:'',
    password:'',
    open:false,
    openChildModal3:false,
    openChildModal:false
    
  },
  reducers: {
    setShowPasswordRedux: (state, action) => {
      const { showPassword } = action.payload
      state.showPassword = showPassword
    },
    setTempCookieRedux: (state, action) => {
      const { tempCookie } = action.payload
      state.tempCookie = tempCookie
    },
    setStepRedux: (state, action) => {
        const { step } = action.payload
        state.step = step
      },
      setCheckboxRedux: (state, action) => {
        const { checkbox } = action.payload
        state.checkbox = checkbox
      },
      setLoadingRedux: (state, action) => {
        const { loading } = action.payload
        state.loading = loading
      },
      setLoginFeedbackRedux: (state, action) => {
        const { loginFeedback } = action.payload
        state.loginFeedback = loginFeedback
      },
      setUsernameRedux: (state, action) => {
        const { username } = action.payload
        state.username = username
      },
      setPasswordRedux: (state, action) => {
        const { password } = action.payload
        state.password = password
      },
      setOpenRedux: (state, action) => {
        const { open } = action.payload
        state.open = open
      },
      setOpenChildModal3Redux: (state, action) => {
        const { openChildModal3 } = action.payload
        state.openChildModal3 = openChildModal3
      },
      setOpenChildModalRedux: (state, action) => {
        const { openChildModal } = action.payload
        state.openChildModal = openChildModal
      },
  },
})

export default loginUserSlice.reducer;

export const {
    setStepRedux,
    setCheckboxRedux,
    setLoadingRedux,
    setLoginFeedbackRedux,
    setUsernameRedux,
    setPasswordRedux,
    setOpenRedux,
    setShowPasswordRedux,
    setTempCookieRedux,
    setOpenChildModal3Redux,
    setOpenChildModalRedux
  
} = loginUserSlice.actions

export const getStepRedux = (state) => state.loginUser.step
export const getCheckboxRedux = (state) => state.loginUser.checkbox
export const getLoadingRedux = (state) => state.loginUser.loading
export const getLoginFeedbackRedux = (state) => state.loginUser.loginFeedback
export const getUsernameRedux = (state) => state.loginUser.username
export const getPasswordRedux = (state) => state.loginUser.password
export const getOpenRedux = (state) => state.loginUser.open
export const getTempCookieRedux = (state) => state.loginUser.tempCookie
export const getShowPasswordRedux = (state) => state.loginUser.showPassword
export const getOpenChildModal3Redux = (state) => state.loginUser.openChildModal3
export const getOpenChildModalRedux = (state) => state.loginUser.openChildModal




